export interface LoginFormValues {
  email: string;
  password: string;
  remember?: boolean;
}

export interface ForgotPasswordFormValues {
  email: string;
}

export interface ResetFormValues {
  email: string;
  password: string;
  confirmPassword: string;
}

export const heading = "sign in";
export const subHeading = "Use your Chartered staff account. Access is by appointment only.";
export const emailId = "the charter email";
export const password = "password";
export const emailPlaceholder = "name@thecharterofficial.com";
export const passwordPlaceholder = "Enter your password";
export const newPasswordPlaceholder = "Enter your new password";
export const forgot_password = "forgot password?";
export const forgotLinkText = "forgot?";
export const keepSignedIn = "Keep me signed in on this device";
export const confirm_password = "confirm password";
export const confirmPlaceholder = "Re-enter your new password";
export const signIn = "sign in";
export const signing = "signing...";
export const setNewPassword = "set new password";
export const createNewPassword = "Create a new password to access your account again";
export const sendResetEmail = "Enter your email address and we'll send you a reset link";
export const supportText = "Use the reset link sent to your inbox to choose a new password";
export const supportText2 =
  "Your new password must match the required format before you can continue";
export const reset = "reset password";
export const resetting = "resetting...";
export const sending = "sending...";
export const continueText = "continue";
export const go_back = "go back";
export const backToSignIn = "back to sign in";
